<script lang="ts">
    import { tick } from "svelte"
    import inputfields from "./"

    let { currentChoices = null, value = $bindable(), label, values = $bindable() }: FieldComponentProps = $props()
    if (!value) value = {}
    values = values || null

    let previewData = $state([])

    const fields = [
        {
            name: "mailboxTotalCount",
            widget: "number",
            label: "Wieviele Briefkästen benötigen Sie?",
            placeholder: "Geben Sie eine Zahl ein",
            defaultValue: 1,
        },
        {
            name: "mailboxHorizontalCount",
            widget: "number",
            label: "Horizontal",
            placeholder: "Geben Sie eine Zahl ein",
            defaultValue: 1,
        },
    ]

    const onTotalChanged = async () => await updateHorizontal()

    const updateHorizontal = async () => {
        await tick()
        if (!value[fields[1].name]) value[fields[1].name] = 1
    }

    const onHorizontalChanged = (valueE: any) => {
        if (valueE) value[fields[1].name] = 1
    }

    $effect(() => {
        // Prepare Preview Data
        previewData = []
        let row = 0
        const totalItems = value[fields[0].name]
        const itemsPerRow = value[fields[1].name]
        if (totalItems && itemsPerRow) {
            for (let i = 1; i <= totalItems; i++) {
                if (!previewData[row]) {
                    previewData[row] = []
                }

                previewData[row].push(i)

                if (itemsPerRow > 1) {
                    if (i > 0 && i % itemsPerRow === 0) row++
                } else row++
            }
        }
    })

    const SvelteComponent = $derived(inputfields[fields[0].widget as keyof typeof inputfields] || inputfields.default)
    const SvelteComponent_1 = $derived(inputfields[fields[1].widget as keyof typeof inputfields] || inputfields.default)
</script>

<div class="mailbox-quantity-input">
    {#if label}
        <label for="">{label}</label>
    {/if}
    <div class="options">
        <div>
            <SvelteComponent
                {...fields[0]}
                bind:value={value[fields[0].name]}
                onInput={onTotalChanged}
                {currentChoices}
            />

            <SvelteComponent_1
                {...fields[1]}
                disabled={!value[fields[0].name]}
                bind:value={value[fields[1].name]}
                onInput={onHorizontalChanged}
                {currentChoices}
            />

            <div class="number-input">
                <label for="">Vertikal (wird automatisch berechnet)</label>
                <input bind:value={previewData.length} readonly />
            </div>
        </div>

        {#if value[fields[0].name]}
            <div class="preview">
                {#key value}
                    <div class="preview-content">
                        <div class="mailboxes">
                            {#each previewData as row (row)}
                                <div class="mailbox-row">
                                    {#each row as i (i)}
                                        <div class="mailbox-example">
                                            <div class="mailbox-example-input"></div>
                                            <div class="mailbox-example-number">
                                                {i}
                                            </div>
                                        </div>
                                    {/each}
                                </div>
                            {/each}
                        </div>
                    </div>
                {/key}
            </div>
        {/if}
    </div>
</div>
